<app-loading *ngIf="loading"></app-loading>

<table class="ts-table" *ngIf="!loading && totalRecords > 0">
    <thead>
        <tr>
            <th class="header-vertical-border">Symbol</th>
            <th class="text-right-numeric header-vertical-border">Quantity</th>
            <th class="text-right-numeric header-vertical-border">Average Price</th>
            <th class="header-vertical-border">Long/Short</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let element of elements$ | async">
            <td>{{element.symbol}}</td>
            <td class="text-right-numeric">{{element.quantity}}</td>
            <td class="text-right-numeric">{{element.avgPrice | currency:'USD':'symbol':'1.2-2'}}</td>
            <td>{{element.longShort}}</td>
        </tr>
    </tbody>
</table>
<app-empty-state *ngIf="totalRecords == 0 && !loading"
    [icon]="faChartPie"
    headline="No positions found"
    hint="This account has no open positions for the selected date."></app-empty-state>
